module.exports = __webpack_public_path__ + "media/images/checkout/garantia-15-dias-09fd2f0e86db8bbde3e9d3dbc360605e.png";